import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-meeting-list',
  templateUrl: './meeting-list.component.html',
  styleUrls: ['./meeting-list.component.css']
})
export class MeetingListComponent implements OnInit {

  @Input() deviceXs: any;
  @Input() deviceLg: any;
  @Input() deviceMd: any;
  @Input() deviceXl: any;

  options: any
  today : any
  currentDate : any
  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';
  constructor() { }

  ngOnInit(): void {
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  }

}
